/**
 * @file tipShareUrl.js
 * @description 移动端外部浏览器打赏：生成微信内打开的深链 URL
 * @module features/comic/utils/tipShareUrl
 */

import { getPreferredOrigin } from '@/shared/utils/seo'

/**
 * @typedef {Object} TipShareUrlInput
 * @property {string} comicId
 * @property {'detail' | 'reader'} source
 * @property {number} [volNum] 阅读器卷号（source=reader 时必填）
 * @property {string} tipCode 打赏档位编码
 */

/**
 * 构建打赏深链（https + tip=1&tipCode），供复制后在微信内打开
 * @param {TipShareUrlInput} input
 * @returns {string}
 */
export function buildTipShareUrl(input) {
  const comicId = String(input.comicId || '').trim()
  const tipCode = String(input.tipCode || '').trim()
  if (!comicId || !tipCode) return ''

  const origin = getPreferredOrigin()
  if (!origin) return ''

  let path = `/comic/${encodeURIComponent(comicId)}`
  if (input.source === 'reader') {
    const volNum = input.volNum
    if (volNum == null || Number.isNaN(Number(volNum))) return ''
    path = `/comic/reader/${encodeURIComponent(comicId)}/${encodeURIComponent(String(volNum))}`
  }

  const params = new URLSearchParams()
  params.set('tip', '1')
  params.set('tipCode', tipCode)

  return `${origin}${path}?${params.toString()}`
}
